import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const StyledAdContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const videoStyles = css`
    width: 100%;
    height: 100%;
`;
